"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.defaultDesignTheme = exports.justifyContentMap = void 0;
const react_1 = require("react");
const theme_1 = require("../components/contexts/theme");
exports.justifyContentMap = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
    spaceBetween: 'justify-between',
    spaceAround: 'justify-around',
    spaceEvenly: 'justify-evenly',
};
exports.defaultDesignTheme = {
    palette: {
        primary: {
            background: ['bg-primary-800'],
            text: ['text-primary-800'],
            textLight: ['text-white'],
            textLighter: ['text-white/75'],
            hover: ['hover:bg-[#F1B53D]'],
            outlined: ['ring-primary-300'],
            textOutlined: [
                'text-primary-800',
                'hover:text-white',
                'hover:bg-red-700',
            ],
        },
        red: {
            background: ['bg-red-800'],
            text: ['text-white'],
            textLight: ['text-white'],
            textLighter: ['text-white/75'],
            hover: ['hover:bg-red-700'],
            outlined: ['ring-red-300'],
            textOutlined: ['text-red-800', 'hover:text-white', 'hover:bg-red-700'],
        },
        white: {
            background: ['bg-white'],
            text: ['text-black'],
            textLight: ['text-gray-600'],
            textLighter: ['text-gray-400'],
            hover: ['hover:bg-gray-200'],
            outlined: ['ring-white'],
            textOutlined: [
                'text-white',
                'hover:text-[#F1B53D]',
                'hover:bg-tranparent',
                'hover:ring-[#F1B53D]',
            ],
        },
        black: {
            background: ['bg-black'],
            text: ['text-white'],
            textLight: ['text-gray-300'],
            textLighter: ['text-gray-100'],
            hover: ['hover:bg-gray-400'],
            outlined: ['ring-gray-300'],
            textOutlined: ['text-black', 'hover:text-white', 'hover:bg-black'],
        },
        gold: {
            background: ['bg-gold'],
            text: ['text-white'],
            textLight: ['text-white'],
            textLighter: ['text-white'],
            hover: ['hover:bg-gold-light'],
            outlined: ['ring-gold-300'],
            textOutlined: [
                'text-gold-800',
                'hover:text-white',
                'hover:bg-gold-light',
            ],
        },
        indigo: {
            background: ['bg-indigo-700'],
            text: ['text-white'],
            textLight: ['text-gray-300'],
            textLighter: ['text-gray-100'],
            hover: ['hover:bg-indigo-900'],
            outlined: ['ring-indigo-300'],
            textOutlined: [
                'text-indigo-800',
                'hover:text-white',
                'hover:bg-indigo-900',
            ],
        },
        teal: {
            background: ['bg-teal'],
            text: ['text-teal-800'],
            textLight: ['text-teal-400'],
            textLighter: ['text-teal-200'],
            hover: ['hover:bg-teal-dark'],
            outlined: ['ring-teal-300'],
            textOutlined: [
                'text-teal-800',
                'hover:text-teal-800',
                'hover:bg-teal-dark',
            ],
        },
        aquamarine: {
            background: ['bg-aquamarine'],
            text: ['text-aquamarine-800'],
            textLight: ['text-aquamarine-400'],
            textLighter: ['text-aquamarine-200'],
            hover: ['hover:bg-aquamarine-dark'],
            outlined: ['ring-aquamarine-300'],
            textOutlined: [
                'text-aquamarine-800',
                'hover:text-aquamarine-800',
                'hover:bg-aquamarine-dark',
            ],
        },
        peach: {
            background: ['bg-peach'],
            text: ['text-white'],
            textLight: ['text-white'],
            textLighter: ['text-white'],
            hover: ['hover:bg-peach-dark'],
            outlined: ['ring-peach-300'],
            textOutlined: [
                'text-peach-800',
                'hover:text-white',
                'hover:bg-peach-dark',
            ],
        },
        beige: {
            background: ['bg-beige'],
            text: ['text-beige-800'],
            textLight: ['text-teal-400'],
            textLighter: ['text-teal-200'],
            hover: ['hover:bg-beige-dark'],
            outlined: ['ring-beige-300'],
            textOutlined: [
                'text-beige-800',
                'hover:text-beige-800',
                'hover:bg-beige-dark',
            ],
        },
        pink: {
            background: ['bg-pink'],
            text: ['text-pink-800'],
            textLight: ['text-pink-400'],
            textLighter: ['text-pink-200'],
            hover: ['hover:bg-pink-dark'],
            outlined: ['ring-pink-300'],
            textOutlined: ['text-pink', 'hover:text-pink-800', 'hover:bg-pink-dark'],
        },
        none: {
            background: ['bg-transparent'],
            text: ['text-gray-700'],
            textLight: ['text-gray-400'],
            textLighter: ['text-gray-200'],
            hover: ['hover:text-gray-600'],
            outlined: ['ring-gray-300'],
            textOutlined: [
                'text-gray-800',
                'hover:text-gray-700',
                'hover:text-gray-600',
            ],
        },
        yellow: {
            background: ['bg-yellow-400'],
            text: ['text-yellow-800'],
            textLight: ['text-yellow-400'],
            textLighter: ['text-yellow-200'],
            hover: ['hover:bg-yellow-500'],
            outlined: ['ring-yellow-300'],
            textOutlined: [
                'text-yellow-800',
                'hover:text-yellow-800',
                'hover:bg-yellow-500',
            ],
        },
        orange: {
            background: ['bg-orange-600'],
            text: ['text-white'],
            textLight: ['text-white'],
            textLighter: ['text-white/75'],
            hover: ['hover:bg-orange-700'],
            outlined: ['ring-orange-300'],
            textOutlined: [
                'text-orange-800',
                'hover:text-white',
                'hover:bg-orange-700',
            ],
        },
        disabled: {
            background: ['bg-gray-300'],
            text: ['text-gray-400'],
            textLight: [''],
            textLighter: [''],
            hover: [''],
            outlined: [''],
            textOutlined: [],
        },
    },
    typography: {
        variants: {
            body: ['font-medium', 'text-fluid-0'],
            caption: ['font-semibold', 'tracking-wider', '-text-fluid-2'],
            label: ['tracking-wider', '-text-fluid-2'],
            button: ['font-medium', 'tracking-wider', '-text-fluid-1'],
            menu: ['text-sm', 'font-medium'],
            h1: ['text-fluid-5'],
            h2: ['text-fluid-4'],
            h3: ['text-fluid-3'],
            h4: ['text-fluid-2'],
            h5: ['text-fluid-1'],
            h6: ['text-fluid-0'],
        },
        gutterBottom: {
            none: ['pb-0'],
            xs: ['pb-2'],
            sm: ['pb-4'],
            md: ['pb-6'],
            lg: ['pb-8'],
            xl: ['pb-10'],
        },
    },
    components: {
        buttonLink: {
            shadow: {
                xs: ['shadow-sm'],
                sm: ['shadow'],
                md: ['shadow-md'],
                lg: ['shadow-lg'],
                xl: ['shadow-xl'],
            },
            shape: {
                none: ['rounded-none'],
                xs: ['rounded-sm'],
                sm: ['rounded'],
                md: ['rounded-md'],
                lg: ['rounded-lg'],
                xl: ['rounded-full'],
            },
            size: {
                xs: ['text-xs', 'px-3', 'py-1'],
                sm: ['text-sm', 'px-4', 'py-2'],
                md: ['text-base', 'px-5', 'py-3'],
                lg: ['text-lg', 'px-6', 'py-4'],
                xl: ['text-xl', 'px-7', 'py-5'],
            },
            variant: {
                contained: [],
                outlined: [' ring-1', ' ring-inset'],
                text: [],
            },
        },
        button: {
            shadow: {
                xs: ['shadow-sm'],
                sm: ['shadow'],
                md: ['shadow-md'],
                lg: ['shadow-lg'],
                xl: ['shadow-xl'],
            },
            shape: {
                round: {
                    xs: ['rounded-sm'],
                    sm: ['rounded'],
                    md: ['rounded-md'],
                    lg: ['rounded-lg'],
                    xl: ['rounded-xl'],
                },
                roundedRight: {
                    xs: ['rounded-r-sm rounded-l-none'],
                    sm: ['rounded-r-sm rounded-l-none'],
                    md: ['rounded-r-md rounded-l-none'],
                    lg: ['rounded-r-lg rounded-l-none'],
                    xl: ['rounded-xl rounded-l-none'],
                },
                roundedLeft: {
                    xs: ['rounded-l-sm rounded-r-none'],
                    sm: ['rounded-l-sm rounded-r-none'],
                    md: ['rounded-l-md rounded-r-none'],
                    lg: ['rounded-l-lg rounded-r-none'],
                    xl: ['rounded-l-xl rounded-r-none'],
                },
            },
            size: {
                xs: ['text-xs', 'px-3', 'py-1'],
                sm: ['text-sm', 'px-4', 'py-2'],
                md: ['text-base', 'px-5', 'py-3'],
                lg: ['text-lg', 'px-6', 'py-4'],
                xl: ['text-xl', 'px-7', 'py-5'],
            },
            variant: {
                contained: [],
                outlined: [' ring-1', ' ring-inset'],
                text: [],
            },
        },
        stack: {
            marginTop: {
                none: ['mt-0'],
                xs: ['mt-2'],
                sm: ['mt-4'],
                md: ['mt-6'],
                lg: ['mt-8'],
                xl: ['mt-10'],
            },
            paddingTop: {
                none: ['pt-0'],
                xs: ['pt-2'],
                sm: ['pt-4'],
                md: ['pt-6'],
                lg: ['pt-8'],
                xl: ['pt-10'],
            },
            paddingX: {
                none: ['px-0'],
                xs: ['px-2'],
                sm: ['px-4'],
                md: ['px-6'],
                lg: ['px-8'],
                xl: ['px-10'],
            },
            paddingY: {
                none: ['py-0'],
                xs: ['py-2'],
                sm: ['py-4'],
                md: ['py-6'],
                lg: ['py-8'],
                xl: ['py-10'],
            },
            direction: {
                row: ['flex'],
                column: ['flex-col'],
            },
            justifyContent: {
                left: ['justify-start', 'max-auto'],
                center: ['justify-center', 'max-auto'],
                right: ['justify-end', 'max-auto'],
                spaceBetween: ['justify-between', 'max-auto'],
                spaceAround: ['justify-around', 'max-auto'],
                spaceEvenly: ['justify-evenly', 'max-auto'],
            },
            maxWith: {
                zero: ['max-w-0'],
                none: ['max-w-none'],
                xs: ['max-w-xs'],
                sm: ['max-w-sm'],
                md: ['max-w-md'],
                lg: ['max-w-lg'],
                xl: ['max-w-xl'],
                '2xl': ['max-w-2xl'],
                '3xl': ['max-w-3xl'],
                '4xl': ['max-w-4xl'],
                '5xl': ['max-w-5xl'],
                '6xl': ['max-w-6xl'],
                '7xl': ['max-w-7xl'],
                full: ['max-w-full'],
                min: ['max-w-min'],
                max: ['max-w-max'],
            },
        },
        divider: {
            direction: {
                row: ['flex-row'],
                column: ['flex-col'],
            },
        },
        list: {
            marginTop: {
                none: ['mt-0'],
                xs: ['mt-2'],
                sm: ['mt-4'],
                md: ['mt-6'],
                lg: ['mt-8'],
                xl: ['mt-10'],
            },
            spacingY: {
                none: ['space-y-0'],
                xs: ['space-y-2'],
                sm: ['space-y-4'],
                md: ['space-y-6'],
                lg: ['space-y-8'],
                xl: ['space-y-10'],
            },
        },
        grid: {
            paddingTop: {
                none: ['pt-0'],
                xs: ['pt-2'],
                sm: ['pt-4'],
                md: ['pt-6'],
                lg: ['pt-8'],
                xl: ['pt-10'],
            },
            paddingBottom: {
                none: ['pb-0'],
                xs: ['pb-2'],
                sm: ['pb-4'],
                md: ['pb-6'],
                lg: ['pb-8'],
                xl: ['pb-10'],
            },
            paddingX: {
                none: ['px-0'],
                xs: ['px-2'],
                sm: ['px-4'],
                md: ['px-6'],
                lg: ['px-8'],
                xl: ['px-10'],
            },
            paddingY: {
                none: ['py-0'],
                xs: ['py-2'],
                sm: ['py-4'],
                md: ['py-6'],
                lg: ['py-8'],
                xl: ['py-10'],
            },
            gap: {
                none: ['gap-0'],
                xs: ['gap-2'],
                sm: ['gap-4'],
                md: ['gap-6'],
                lg: ['gap-8'],
                xl: ['gap-10'],
            },
            rows: {
                one: ['grid-rows-1'],
                two: ['grid-rows-2'],
                three: ['grid-rows-3'],
                four: ['grid-rows-4'],
                five: ['grid-rows-5'],
                six: ['grid-rows-6'],
                seven: ['grid-rows-7'],
                eight: ['grid-rows-8'],
                nine: ['grid-rows-9'],
            },
            columns: {
                one: ['grid-cols-1'],
                two: ['grid-cols-2'],
                three: ['grid-cols-3'],
                four: ['grid-cols-4'],
                five: ['grid-cols-5'],
                six: ['grid-cols-6'],
                seven: ['grid-cols-7'],
                eight: ['grid-cols-8'],
                nine: ['grid-cols-9'],
            },
            sm: {
                rows: {
                    one: ['sm:grid-rows-1'],
                    two: ['sm:grid-rows-2'],
                    three: ['sm:grid-rows-3'],
                    four: ['sm:grid-rows-4'],
                    five: ['sm:grid-rows-5'],
                    six: ['sm:grid-rows-6'],
                    seven: ['sm:grid-rows-7'],
                    eight: ['sm:grid-rows-8'],
                    nine: ['sm:grid-rows-9'],
                },
                columns: {
                    one: ['sm:grid-cols-1'],
                    two: ['sm:grid-cols-2'],
                    three: ['sm:grid-cols-3'],
                    four: ['sm:grid-cols-4'],
                    five: ['sm:grid-cols-5'],
                    six: ['sm:grid-cols-6'],
                    seven: ['sm:grid-cols-7'],
                    eight: ['sm:grid-cols-8'],
                    nine: ['sm:grid-cols-9'],
                },
            },
            md: {
                rows: {
                    one: ['md:grid-rows-1'],
                    two: ['md:grid-rows-2'],
                    three: ['md:grid-rows-3'],
                    four: ['md:grid-rows-4'],
                    five: ['md:grid-rows-5'],
                    six: ['md:grid-rows-6'],
                    seven: ['md:grid-rows-7'],
                    eight: ['md:grid-rows-8'],
                    nine: ['md:grid-rows-9'],
                },
                columns: {
                    one: ['md:grid-cols-1'],
                    two: ['md:grid-cols-2'],
                    three: ['md:grid-cols-3'],
                    four: ['md:grid-cols-4'],
                    five: ['md:grid-cols-5'],
                    six: ['md:grid-cols-6'],
                    seven: ['md:grid-cols-7'],
                    eight: ['md:grid-cols-8'],
                    nine: ['md:grid-cols-9'],
                },
            },
            lg: {
                rows: {
                    one: ['lg:grid-rows-1'],
                    two: ['lg:grid-rows-2'],
                    three: ['lg:grid-rows-3'],
                    four: ['lg:grid-rows-4'],
                    five: ['lg:grid-rows-5'],
                    six: ['lg:grid-rows-6'],
                    seven: ['lg:grid-rows-7'],
                    eight: ['lg:grid-rows-8'],
                    nine: ['lg:grid-rows-9'],
                },
                columns: {
                    one: ['lg:grid-cols-1'],
                    two: ['lg:grid-cols-2'],
                    three: ['lg:grid-cols-3'],
                    four: ['lg:grid-cols-4'],
                    five: ['lg:grid-cols-5'],
                    six: ['lg:grid-cols-6'],
                    seven: ['lg:grid-cols-7'],
                    eight: ['lg:grid-cols-8'],
                    nine: ['lg:grid-cols-9'],
                },
            },
            xl: {
                rows: {
                    one: ['xl:grid-rows-1'],
                    two: ['xl:grid-rows-2'],
                    three: ['xl:grid-rows-3'],
                    four: ['xl:grid-rows-4'],
                    five: ['xl:grid-rows-5'],
                    six: ['xl:grid-rows-6'],
                    seven: ['xl:grid-rows-7'],
                    eight: ['xl:grid-rows-8'],
                    nine: ['xl:grid-rows-9'],
                },
                columns: {
                    one: ['xl:grid-cols-1'],
                    two: ['xl:grid-cols-2'],
                    three: ['xl:grid-cols-3'],
                    four: ['xl:grid-cols-4'],
                    five: ['xl:grid-cols-5'],
                    six: ['xl:grid-cols-6'],
                    seven: ['xl:grid-cols-7'],
                    eight: ['xl:grid-cols-8'],
                    nine: ['xl:grid-cols-9'],
                },
            },
        },
        dropDown: {
            size: {
                xs: ['w-16'],
                sm: ['w-24'],
                md: ['w-32'],
                lg: ['w-64'],
                xl: ['w-96'],
            },
        },
        tag: {
            size: {
                xs: ['-text-fluid-2', 'font-thin'],
                sm: ['-text-fluid-1', 'font-thin'],
                md: ['text-fluid-0', 'font-thin'],
                lg: ['text-fluid-0', 'font-thin'],
                xl: ['text-fluid-0', 'font-thin'],
            },
        },
        productCard: {
            size: {
                xs: ['w-40', 'md:w-32'],
                sm: ['w-40', 'md:w-48'],
                md: ['w-40', 'md:w-64'],
                lg: ['w-full', 'md:w-80'],
                xl: ['w-full', 'md:w-96'],
            },
            eyebrow: [' '],
            title: [
                'lg:leading-[31.2px]',
                'leading-[22.4px]',
                'lg:text-[24px]',
                'text-[14px]',
                'font-bold',
                `font-['Galano Classic']`,
            ],
            price: [
                'font-normal',
                'leading-[28.8px]',
                'text-[14px]',
                'lg:text-[18px]',
            ],
            description: [' '],
            container: [
                'group',
                'relative',
                'flex',
                'flex-col',
                'overflow-hidden',
                'border',
                'border-gray-200',
                'bg-white',
            ],
        },
        footer: {
            topLinks: ['text-base', 'white'],
            bottomLinks: ['text-base', 'white'],
        },
        incentive: {
            title: ['text-gray-700', 'text-[36px]', 'leading-[43.2px]'],
            panelTitle: ['text-gray-700', 'text-xl', 'uppercase'],
            panelDescription: [
                'text-gray-700',
                'text-base',
                'text-[16px]',
                'leading-[25.6px]',
            ],
        },
        newsLetter: {
            title: ['text-gray-700', 'font-normal', 'text-3xl'],
            helpingText: ['text-gray-500', 'font-normal', 'text-small', 'pt-2'],
            emailInput: ['h-11', 'rounded-none'],
            signUpButton: ['h-11'],
            emailInputError: ['font-light', 'text-red-700', 'mt-1', 'flex'],
        },
        subscriptionConfirmation: {
            icon: ['h-[34px]', 'w-[34px]'],
            title: ['text-gray-700', 'font-normal', 'text-3xl'],
            helpingText: ['text-gray-500', 'font-normal', 'text-small'],
        },
        signIn: {
            title: ['text-gray-700', 'font-bold', 'text-3xl', 'text-center'],
        },
        step: {
            selected: [
                'text-gray-700',
                'font-bold',
                'text-regular',
                'text-sm',
                'uppercase',
                'px-4',
                'py-2',
            ],
            unselected: [
                'text-gray-500',
                'font-semibold',
                'text-sm',
                'uppercase',
                'px-4',
                'py-2',
            ],
        },
        stepper: {
            container: [
                'flex',
                'flex-row',
                'justify-between',
                'items-center',
                'border-y',
                'border-gray-200',
                'py-2',
            ],
        },
        addressCard: {
            root: [
                'border-neutral-400',
                'p-4',
                'md:px-5',
                'md:py-6',
                '2xl:px-6',
                'rounded-md',
                'border',
            ],
            contentWraper: ['p-4'],
            labelWraper: ['text-xl'],
            label: ['md:text-base'],
            address: ['py-5', 'text-secondary-black'],
            editButton: ['px-7', 'py-3'],
        },
        productTile: {
            root: ['space-x-2 w-full'],
            productImg: [
                'h-16',
                'w-16',
                'rounded-lg',
                'border',
                'border-gray-200',
                'sm:h-16',
                'sm:w-16',
            ],
            productDetailsWraper: ['w-40', 'px-4'],
            productName: ['max-w-sm', 'px-2', 'text-gray-900', 'font-medium'],
            productPrice: ['px-2', 'text-gray-500'],
            productQuantity: ['w-24', 'px-2'],
            removeButton: ['ml-4', 'font-medium', 'sm:ml-0', 'sm:mt-2'],
            removeButtonText: ['text-red-600', 'hover:text-red-500'],
        },
        emptyCart: {
            root: ['h-full', 'space-y-2'],
            icon: ['pt-12'],
        },
        cartFooter: {
            root: ['bg-[#FFF6EA]', 'py-6', 'px-8', 'lg:block', 'lg:pb-0'],
            promocodeSection: ['mb-4', 'border-b', 'border-neutral-400'],
            transactionDetailsSection: ['border-b', 'border-neutral-400'],
            transactionItem: ['text-gray-500'],
            totalSection: ['mt-2', 'font-medium'],
            completePurchase: ['mt-8', 'lg:block'],
        },
        edit: {
            editIconWraper: ['shadow-100', 'bg-neutral-200', 'h-10', 'w-10'],
            editIcon: ['h-5', 'w-5', 'text-black', 'text-danger'],
            editText: ['text-danger'],
        },
        infoField: {
            root: ['mr-10'],
        },
        infoCard: {
            title: [
                'mb-4',
                'ml-4',
                'lg:mb-4',
                'text-gray-700',
                'font-bold',
                'text-2xl',
                'md:text-4xl',
                'pr-6',
            ],
            contentWrapper: ['py-6', 'px-4', 'md:pr-7', 'lg:pr-11'],
        },
        productSort: {
            root: ['relative', 'min-w-[200px]'],
            wrapper: ['border-0', 'bg-transparent', 'shadow-none'],
            label: ['text-[#B7002A]'],
            value: ['text-[#000]'],
        },
        categoryNavigationCarousel: {
            root: ['mx-auto', 'my-10', 'w-full', 'bg-[#FFF6EA]'],
            menuItem: [
                'flex',
                'h-[105px]',
                'w-[130px]',
                'flex-col',
                'items-center',
                'justify-center',
                'text-center',
            ],
            menuIcon: ['flex', 'h-[60px]', 'items-center', 'justify-center'],
        },
        defaultAddressCard: {
            title: [
                'mb-4',
                'ml-4',
                'lg:mb-4',
                'text-gray-700',
                'font-bold',
                'text-2xl',
                'md:text-4xl',
                'pr-6',
            ],
            contentWrapper: ['py-6', 'px-4', 'md:pr-7', 'lg:pr-11'],
            addressesWraper: ['gap-8', 'px-4', 'py-6', 'pr-6'],
        },
    },
};
const useTheme = () => {
    const value = (0, react_1.useContext)(theme_1.ThemeContext);
    return value.theme ? value.theme : exports.defaultDesignTheme;
};
exports.useTheme = useTheme;
